"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Contract = require("@tableau/api-external-contract-js");
var api_external_contract_js_1 = require("@tableau/api-external-contract-js");
var api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
var api_shared_js_1 = require("@tableau/api-shared-js");
var FilterChangedEvent_1 = require("../Events/FilterChangedEvent");
var MarksSelectedEvent_1 = require("../Events/MarksSelectedEvent");
var SummaryDataChangedEvent_1 = require("../Events/SummaryDataChangedEvent");
var WorksheetFormattingChangedEvent_1 = require("../Events/WorksheetFormattingChangedEvent");
var ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
var Dashboard_1 = require("./Dashboard");
var Sheet_1 = require("./Sheet");
var Worksheet = /** @class */ (function (_super) {
    __extends(Worksheet, _super);
    function Worksheet(_worksheetImpl) {
        var _this = _super.call(this, _worksheetImpl) || this;
        _this._worksheetImpl = _worksheetImpl;
        // Call to initialize events and then call down to the event listener manager to handle things
        _this.initializeEvents().forEach(function (e) { return _this.addNewEventType(e); });
        return _this;
    }
    Object.defineProperty(Worksheet.prototype, "parentDashboard", {
        get: function () {
            // This should never happen for Extensions if the DashboardImpls are created correctly
            if (this._worksheetImpl.parentDashboard == null) {
                throw new api_shared_js_1.TableauError(Contract.SharedErrorCodes.ImplementationError, "Parent dashboard not implemented");
            }
            return new Dashboard_1.Dashboard(this._worksheetImpl.parentDashboard);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Worksheet.prototype, "backgroundColor", {
        get: function () {
            if (this._worksheetImpl.backgroundColor == null) {
                throw new api_shared_js_1.TableauError(Contract.SharedErrorCodes.ImplementationError, "Worksheet background color is not available");
            }
            return this._worksheetImpl.backgroundColor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Worksheet.prototype, "formatting", {
        get: function () {
            if (this._worksheetImpl.formatting == null) {
                throw new api_shared_js_1.TableauError(Contract.SharedErrorCodes.ImplementationError, "Worksheet formatting information is not available");
            }
            return this._worksheetImpl.formatting;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Helper method which goes through and registers each event type this impl knows about
     * with the NotificationService. It returns an array of SingleEventManager objects which
     * can then be passed to an EventListenerManager to handle user registration / unregistration.
     *
     * @param {Worksheet} worksheet The worksheet object which will be included with the event notifications
     * @returns {Array<SingleEventManager>} Collection of event managers to pass to an EventListenerManager
     */
    Worksheet.prototype.initializeEvents = function () {
        var _this = this;
        var results = new Array();
        var notificationService;
        try {
            notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* Notification */);
        }
        catch (e) {
            // If we don't have this service registered, just return
            return results;
        }
        // Initialize all of the event managers we'll need (one for each event type)
        var marksEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.MarkSelectionChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.SelectedMarksChanged, function (model) {
            var visualId = model;
            return _this.visualIdsAreEqual(visualId, _this._worksheetImpl.visualId);
        }, function () { return marksEvent.triggerEvent(function () { return new MarksSelectedEvent_1.MarksSelectedEvent(_this); }); });
        var filterEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.FilterChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.FilterChanged, function (model) {
            var filterEventResponse = model;
            return _this._worksheetImpl.visualId.worksheet === filterEventResponse.visualId.worksheet;
        }, function (event) {
            filterEvent.triggerEvent(function () { return new FilterChangedEvent_1.FilterChangedEvent(_this, event.fieldName, event.fieldId); });
        });
        var summaryDataEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.SummaryDataChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.SummaryDataChanged, function (model) {
            var summaryDataEventResponse = model;
            return _this._worksheetImpl.visualId.worksheet === summaryDataEventResponse.visualId.worksheet;
        }, function (event) {
            summaryDataEvent.triggerEvent(function () { return new SummaryDataChangedEvent_1.SummaryDataChangedEvent(_this); });
        });
        var worksheetFormattingChangedEvent = new api_shared_js_1.SingleEventManagerImpl(api_external_contract_js_1.TableauEventType.WorksheetFormattingChanged);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.WorksheetFormattingChanged, function (model) {
            var worksheetFormattingChangedEvent = model;
            return _this._worksheetImpl.visualId.worksheet === worksheetFormattingChangedEvent.visualId.worksheet;
        }, function (eventFormatting) {
            worksheetFormattingChangedEvent.triggerEvent(function () { return new WorksheetFormattingChangedEvent_1.WorksheetFormattingChangedEvent(_this, eventFormatting); });
        });
        results.push(marksEvent);
        results.push(filterEvent);
        results.push(summaryDataEvent);
        results.push(worksheetFormattingChangedEvent);
        return results;
    };
    Worksheet.prototype.applyFilterAsync = function (fieldName, values, updateType, options) {
        return this._worksheetImpl.applyFilterAsync(fieldName, values, updateType, options);
    };
    Worksheet.prototype.applyRangeFilterAsync = function (fieldName, filterOptions) {
        return this._worksheetImpl.applyRangeFilterAsync(fieldName, filterOptions);
    };
    Worksheet.prototype.applyHierarchicalFilterAsync = function (fieldName, values, updateType, options) {
        return this._worksheetImpl.applyHierarchicalFilterAsync(fieldName, values, updateType, options);
    };
    Worksheet.prototype.applyRelativeDateFilterAsync = function (fieldName, options) {
        return this._worksheetImpl.applyRelativeDateFilterAsync(fieldName, options);
    };
    Worksheet.prototype.clearFilterAsync = function (fieldName) {
        return this._worksheetImpl.clearFilterAsync(fieldName);
    };
    Worksheet.prototype.getDataSourcesAsync = function () {
        return this._worksheetImpl.getDataSourcesAsync();
    };
    Worksheet.prototype.getFiltersAsync = function () {
        return this._worksheetImpl.getFiltersAsync();
    };
    Worksheet.prototype.getSelectedMarksAsync = function () {
        return this._worksheetImpl.getSelectedMarksAsync();
    };
    Worksheet.prototype.getHighlightedMarksAsync = function () {
        return this._worksheetImpl.getHighlightedMarksAsync();
    };
    Worksheet.prototype.getSummaryDataAsync = function (options) {
        return this._worksheetImpl.getSummaryDataAsync(options);
    };
    Worksheet.prototype.getSummaryDataReaderAsync = function (pageRowCount, options) {
        return this._worksheetImpl.getSummaryDataReaderAsync(pageRowCount, options);
    };
    Worksheet.prototype.getSummaryColumnsInfoAsync = function () {
        return this._worksheetImpl.getSummaryColumnsInfoAsync();
    };
    Worksheet.prototype.getUnderlyingDataAsync = function (options) {
        console.warn('Worksheet.getUnderlyingDataAsync is deprecated. Please use ' +
            'Worksheet.getUnderlyingTablesAsync and Worksheet.getUnderlyingTableDataAsync');
        return this._worksheetImpl.getUnderlyingDataAsync(options);
    };
    Worksheet.prototype.getUnderlyingTablesAsync = function () {
        return this._worksheetImpl.getUnderlyingTablesAsync();
    };
    Worksheet.prototype.getUnderlyingTableDataAsync = function (logicalTableId, options) {
        return this._worksheetImpl.getUnderlyingTableDataAsync(logicalTableId, options);
    };
    Worksheet.prototype.getUnderlyingTableDataReaderAsync = function (logicalTableId, pageRowCount, options) {
        return this._worksheetImpl.getUnderlyingTableDataReaderAsync(logicalTableId, pageRowCount, options);
    };
    Worksheet.prototype.getVisualSpecificationAsync = function () {
        return this._worksheetImpl.getVisualSpecificationAsync();
    };
    Worksheet.prototype.addMarksCardFieldsAsync = function (marksCardIndex, encodingType, columns, startIndex) {
        return this._worksheetImpl.addMarksCardFieldsAsync(marksCardIndex, encodingType, columns, startIndex);
    };
    Worksheet.prototype.moveMarksCardFieldAsync = function (marksCardIndex, fromIndex, toIndex, fieldCount) {
        if (fieldCount === void 0) { fieldCount = 1; }
        return this._worksheetImpl.moveMarksCardFieldAsync(marksCardIndex, fromIndex, toIndex, fieldCount);
    };
    Worksheet.prototype.spliceMarksCardFieldsAsync = function (marksCardIndex, encodingType, startIndex, deleteCount, columns) {
        return this._worksheetImpl.spliceMarksCardFieldsAsync(marksCardIndex, encodingType, startIndex, deleteCount, columns);
    };
    Worksheet.prototype.clearSelectedMarksAsync = function () {
        return this._worksheetImpl.clearSelectedMarksAsync();
    };
    Worksheet.prototype.selectMarksByIDAsync = function (marksInfo, updateType) {
        return this._worksheetImpl.selectMarksByIdAsync(marksInfo, updateType);
    };
    Worksheet.prototype.selectMarksByValueAsync = function (selections, selectionUpdateType) {
        return this._worksheetImpl.selectMarksByValueAsync(selections, selectionUpdateType);
    };
    Worksheet.prototype.selectMarksByIdAsync = function (selections, selectionUpdateType) {
        return this._worksheetImpl.selectMarksByIdAsync(selections, selectionUpdateType);
    };
    Worksheet.prototype.annotateMarkAsync = function (mark, annotationText) {
        return this._worksheetImpl.annotateMarkAsync(mark, annotationText);
    };
    Worksheet.prototype.getAnnotationsAsync = function () {
        return this._worksheetImpl.getAnnotationsAsync();
    };
    Worksheet.prototype.removeAnnotationAsync = function (annotation) {
        return this._worksheetImpl.removeAnnotationAsync(annotation);
    };
    Worksheet.prototype.hoverTupleAsync = function (hoveredTuple, tooltip, allowHoverActions) {
        if (allowHoverActions === void 0) { allowHoverActions = true; }
        return this._worksheetImpl.hoverTupleAsync(hoveredTuple, tooltip, allowHoverActions);
    };
    Worksheet.prototype.selectTuplesAsync = function (selectedTuples, selectOption, tooltip) {
        return this._worksheetImpl.selectTuplesAsync(selectedTuples, selectOption, tooltip);
    };
    Worksheet.prototype.getTooltipTextAsync = function (tupleId) {
        return this._worksheetImpl.getTooltipTextAsync(tupleId);
    };
    Worksheet.prototype.leaveMarkNavigationAsync = function () {
        return this._worksheetImpl.leaveMarkNavigationAsync();
    };
    Worksheet.prototype.editAliasesDialogAsync = function (fieldName) {
        return this._worksheetImpl.editAliasesDialogAsync(fieldName);
    };
    Worksheet.prototype.visualIdsAreEqual = function (a, b) {
        return (a &&
            b &&
            a.worksheet === b.worksheet &&
            a.dashboard === b.dashboard &&
            a.storyboard === b.storyboard &&
            a.storyPointID === b.storyPointID);
    };
    return Worksheet;
}(Sheet_1.Sheet));
exports.Worksheet = Worksheet;
//# sourceMappingURL=Worksheet.js.map